import { render, staticRenderFns } from "./TDrecommendations.vue?vue&type=template&id=6a78d0fd"
import script from "./TDrecommendations.vue?vue&type=script&lang=js"
export * from "./TDrecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports